export type Language = 'de' | 'fr' | 'it';

export enum LanguageEnum {
    DE = 'de',
    FR = 'fr',
    IT = 'it',
}

export interface MultiLanguageProperty {
    [LanguageEnum.DE]: string;
    [LanguageEnum.FR]: string;
    [LanguageEnum.IT]: string;
}
